import { findKey } from 'lodash'

import citizenships from './citizenships.js'


export default (citizenship) => findKey(citizenships, (item) => item === citizenship)
